import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Checkbox } from 'components/ui';

const ToggleIsMicrosoft = () => {
  const { control, watch, setValue } = useFormContext();
  const forceChoose = watch('force_choose');

  return (
    <Controller
      control={control}
      name="isMicrosoft"
      render={({ field: { value, onChange } }) => {
        return (
          <section className="send-mail-form__section">
            <div>
              <Checkbox
                checked={value}
                onChange={({ target: { checked } }) => {
                  onChange(checked);
                  if (!['SendGrid', 'SparkPost', '-1'].includes(forceChoose)) {
                    setValue('force_choose', '-1');
                  }
                }}
              >
                Is Microsoft Emails
              </Checkbox>
            </div>
          </section>
        );
      }}
    />
  );
};

export default ToggleIsMicrosoft;
